import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {
    AvailabilityFragment,
    AvailabilityFragment_times as Times,
} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {useSetAvailability} from '../graphql/hooks/use-set-availability';
import {CurrentTimeInZone} from '../meeting-hosts';

import {DaysConfig} from './days-config';

import styles from './availability-config.module.css';

export type AvailabilityTime = {
    dayOfWeek: string;
    startTime: string | null | undefined;
    endTime: string | null | undefined;
};

type Props = {
    availability: AvailabilityFragment;
    postSave: () => void;
    hideTimezoneLabel: boolean;
};

export function AvailabilityConfig(props: Props) {
    const [availabilityTimes, setAvailabilityTimes] = React.useState<Times[]>(
        props.availability.times
    );
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const setAvailability = useSetAvailability();
    const {user} = useGetSessionUser();

    return (
        <>
            {user && (
                <>
                    <div className='flex justify-sb'>
                        <div>
                            {!props.hideTimezoneLabel && (
                                <>
                                    <div className={styles['timezone-label']}>
                                        Times displayed in:
                                    </div>
                                    <CurrentTimeInZone timezone={user.timezone} />
                                </>
                            )}
                        </div>
                        <SaveButton
                            isSaving={isSaving}
                            buttonText='Save changes'
                            savingText='Saving…'
                            successText='Saved!'
                            resetOnComplete={true}
                            // @ts-expect-error
                            onClick={() => {
                                setIsSaving(true);

                                setAvailability({
                                    id: props.availability.id,
                                    newTimes: availabilityTimes.map((times) => {
                                        return {
                                            day: times.day,
                                            startTime: times.startTime,
                                            endTime: times.endTime,
                                        };
                                    }),
                                }).then(() => {
                                    props.postSave();
                                    setIsSaving(false);
                                });
                            }}
                        />
                    </div>
                    <Divider variant='line--horizontal' spacing={12} />
                </>
            )}
            <StackLegacy spacing={8}>
                <DaysConfig
                    availabilityTimes={availabilityTimes}
                    setAvailabilityTimes={setAvailabilityTimes}
                />
            </StackLegacy>
        </>
    );
}
